// ============================================================
// Kaaleen Haus — German (Deutsch) Translation Dictionary
// ============================================================
export const de = {

  // ─── Navbar ───────────────────────────────────────────────
  nav: {
    shop: 'Teppiche',
    style: 'Stil',
    stories: 'Geschichten',
    blog: 'Blog',
    custom: 'Maßanfertigung',
    contact: 'Kontakt',
    trade: 'Großhandel',
    orders: 'Bestellungen',
    admin: 'Admin',
    signOut: 'Abmelden',
    myCart: 'Mein Warenkorb',
    myOrders: 'Meine Bestellungen',
    search: 'Suchen...',
    adminDashboard: '⚙️ Admin-Dashboard',
    viewAllRugs: 'Alle Teppiche ansehen',
    storiesSection: {
      label: 'Redaktionell',
      title: 'Die Geschichten hinter jedem Teppich',
      viewAll: 'Alle Geschichten ansehen',
    },
    megaHeadings: {
      rugs: 'Teppiche',
      size: 'Größe',
      colors: 'Farben',
      room: 'Raum',
      shape: 'Form',
      material: 'Material',
      construction: 'Verarbeitung',
    },
    topStrip: {
      freeShipping: (amount) => `KOSTENLOSER VERSAND AB €${amount}`,
      contactUs: 'KONTAKTIEREN SIE UNS',
    },
    langToggle: { de: '🇩🇪 DE', en: '🇬🇧 EN' },
  },

  // ─── Home Page ────────────────────────────────────────────
  home: {
    hero: {
      since: 'Seit 1965',
      slides: [
        {
          eyebrow: 'Bhadohi Atelier-Auswahl',
          title: 'Stille Eleganz, täglich handgewebt',
          subtitle: 'Entworfen für geschichtete Interieurs mit zeitlosem Handwerk im Mittelpunkt.',
          collectionLabel: 'Kollektion entdecken',
          offerLabel: 'Saisonangebot',
        },
        {
          eyebrow: 'Neue Ankunfts-Serie',
          title: 'Moderne Webereien für warme Räume',
          subtitle: 'Sanfte Töne, starke Texturen und handwerkliche Präzision in jedem Knoten.',
          collectionLabel: 'Neue Kollektion ansehen',
          offerLabel: 'Limitiertes Angebot',
        },
        {
          eyebrow: 'Studio-Auswahl',
          title: 'Ausdrucksstarke Teppiche, verfeinerte Gestaltung',
          subtitle: 'Geschaffen, um Wohnzimmer, Suiten und kuratierte Gewerberäume zu veredeln.',
          collectionLabel: 'Kollektion durchstöbern',
          offerLabel: 'Angebot freischalten',
        },
        {
          eyebrow: 'Signatur-Haushaltsstücke',
          title: 'Handwerkserbe in zeitgenössischer Form',
          subtitle: 'Eine ruhige, edle Palette für moderne Architektur geschaffen.',
          collectionLabel: 'Kollektion ansehen',
          offerLabel: 'Aktuelles Angebot',
        },
      ],
    },
    trust: [
      { icon: '✦', label: 'Handgefertigt', sub: 'Von Meisterwebern' },
      { icon: '◈', label: 'Premium-Materialien', sub: 'Wolle, Seide & Naturfasern' },
      { icon: '◎', label: 'Hergestellt in Bhadohi', sub: 'Indiens Teppichhauptstadt' },
      { icon: '◇', label: 'B2B-Großhandel', sub: 'Exklusive Großhandelspreise' },
    ],
    atelier: {
      title: 'Unser Atelier entdecken',
      subtitles: ['Die Kollektion', 'Die Weberei', 'Die Ästhetik', 'Das Erbe'],
    },
    bestsellers: {
      label: 'SAISONALE FAVORITEN',
      title: 'Die Bestseller',
      viewAll: 'Gesamte Galerie ansehen',
      handcrafted: 'Handgefertigt',
      from: 'Ab',
    },
    heritage: {
      label: 'UNSER ERBE',
      since: 'Seit 1984',
      title1: '180 Hände,',
      title2: 'ein Meisterstück',
      body1: 'Im Herzen von Bhadohi, Indien, ist Weben mehr als ein Handwerk – es ist ein genetisches Gedächtnis, das über Generationen weitergegeben wird. Ein einziger Kaaleen Haus Teppich repräsentiert über 2.000 Stunden fokussierter Hingabe.',
      body2: 'Von der Beschaffung nachhaltiger Himalaya-Wolle bis zur letzten Wäsche und Glanzverfeinerung – jeder Schritt wird von Meisterhandwerkern ausgeführt, die den langsamen Luxusprozess über Jahrzehnte perfektioniert haben.',
      cta: 'Unser Erbe',
    },
    newBanner: {
      sub: 'Herbst / Winter 25',
      title: 'Neue Saison, neue Webereien',
      btn: 'Die Kollektion entdecken',
    },
    trade: {
      title: 'Werden Sie Teil unseres Handelsprogramms',
      text: 'Wir arbeiten mit Architekten, Innenarchitekten und Gastgewerbe-Führungskräften weltweit zusammen, um maßgeschneiderte Textillösungen zu schaffen. Genießen Sie exklusive Preise, personalisierte Musterbestellung und umfassendes Produktionsmanagement.',
      cta: 'Jetzt anfragen',
    },
  },

  // ─── Shop Page ────────────────────────────────────────────
  shop: {
    title: 'Alle Teppiche',
    subtitle: 'Entdecken Sie unsere atemberaubende Kollektion handgefertigter Teppiche. Von den neuesten Designs bis zu einzigartigen Mustern bieten wir eine Vielzahl von Stilen für jeden Raum.',
    home: 'Startseite',
    rugs: 'Teppiche',
    loading: 'Kollektion wird geladen...',
    noProducts: 'Keine Produkte gefunden',
    noProductsSub: 'Produkte erscheinen hier, sobald sie im Admin-Panel hinzugefügt wurden.',
    filterBy: 'FILTERN NACH',
    sortBy: 'SORTIEREN NACH',
    sortNewest: 'Neueste',
    sortPriceLow: 'Preis: Aufsteigend',
    sortPriceHigh: 'Preis: Absteigend',
    sortName: 'Name: A–Z',
    products: 'Produkte',
    product: 'Produkt',
    handcrafted: 'Handgefertigt',
    newBadge: 'Neu',
    from: 'Ab',
    mobileFilter: 'Filter',
    filters: {
      category: 'KATEGORIE',
      allRugs: 'Alle Teppiche',
      size: 'GRÖSSE',
      color: 'FARBE',
      room: 'RAUM',
      shape: 'FORM',
      material: 'MATERIAL',
      construction: 'VERARBEITUNG',
    },
    filterLabels: {
      sizes: { Small: 'Klein', Medium: 'Mittel', Large: 'Groß', Oversize: 'Übergröße' },
      colors: {
        Blue: 'Blau', Red: 'Rot', Green: 'Grün', Yellow: 'Gelb',
        'Ivory / White': 'Elfenbein / Weiß', Grey: 'Grau', Black: 'Schwarz',
        Orange: 'Orange', Pink: 'Rosa', Purple: 'Lila', Brown: 'Braun',
        Beige: 'Beige', 'Multi Color': 'Mehrfarbig',
      },
      rooms: {
        'Living Room': 'Wohnzimmer', 'Dining Room': 'Esszimmer',
        Bedroom: 'Schlafzimmer', 'Kids Room': 'Kinderzimmer',
        'Outdoor/Indoor': 'Außen/Innen',
      },
      shapes: {
        Rectangle: 'Rechteck', Irregular: 'Unregelmäßig', Round: 'Rund',
        Runner: 'Läufer', Oval: 'Oval', Square: 'Quadrat',
      },
      materials: {
        Wool: 'Wolle', 'Wool & Bamboo Silk': 'Wolle & Bambusseide',
        'Wool & Silk': 'Wolle & Seide', Silk: 'Seide',
        Viscose: 'Viskose', 'Jute & Hemp': 'Jute & Hanf',
        Cotton: 'Baumwolle', Polyester: 'Polyester',
        'Afghan Wool': 'Afghanische Wolle', Acrylic: 'Acryl',
      },
      constructions: {
        'Hand Knotted': 'Handgeknüpft', 'Hand Tufted': 'Handgetuftet',
        'Hand Loom': 'Handwebstuhl', 'Flat Weaves': 'Flachgewebe',
        Shag: 'Hochflor', 'Wall Décor': 'Wanddeko',
      },
    },
  },

  // ─── Product Detail ───────────────────────────────────────
  product: {
    home: 'Startseite',
    shop: 'Teppiche',
    addToCart: 'In den Warenkorb',
    buyNow: 'Jetzt kaufen',
    selectSize: 'Größe wählen',
    size: 'Größe',
    material: 'Material',
    construction: 'Verarbeitung',
    color: 'Farbe',
    shape: 'Form',
    room: 'Raum',
    description: 'Beschreibung',
    reviews: 'Bewertungen',
    writeReview: 'Bewertung schreiben',
    dispatchIn: 'Versand in',
    workingDays: 'Werktagen',
    inStock: 'Auf Lager',
    madeToOrder: 'Auf Bestellung',
    sku: 'Art.-Nr.',
    category: 'Kategorie',
    from: 'Ab',
    freeShipping: 'Kostenloser Versand',
    deliveryNote: 'Lieferhinweis',
    relatedProducts: 'Ähnliche Teppiche',
    noReviews: 'Noch keine Bewertungen',
    submitReview: 'Bewertung abgeben',
    reviewName: 'Ihr Name',
    reviewComment: 'Ihre Bewertung',
    stockLeft: (n) => `Nur noch ${n} auf Lager`,
  },

  // ─── Cart ─────────────────────────────────────────────────
  cart: {
    title: 'Mein Warenkorb',
    empty: 'Ihr Warenkorb ist leer',
    emptySub: 'Erkunden Sie unsere Kollektion und fügen Sie Produkte hinzu.',
    continueShopping: 'Weiter einkaufen',
    product: 'Produkt',
    price: 'Preis',
    quantity: 'Menge',
    total: 'Gesamt',
    remove: 'Entfernen',
    subtotal: 'Zwischensumme',
    shipping: 'Versand',
    orderTotal: 'Gesamtbetrag',
    checkout: 'Zur Kasse',
    proceedCheckout: 'Jetzt bezahlen',
    shippingInfo: 'Lieferinformationen',
    fullName: 'Vollständiger Name',
    email: 'E-Mail-Adresse',
    phone: 'Telefonnummer',
    address: 'Lieferadresse',
    city: 'Stadt',
    state: 'Bundesland / Region',
    pincode: 'Postleitzahl',
    country: 'Land',
    paySecurely: 'Sicher bezahlen',
    orderSummary: 'Bestellübersicht',
    items: (n) => `${n} ${n === 1 ? 'Artikel' : 'Artikel'}`,
  },

  // ─── Login ────────────────────────────────────────────────
  login: {
    title: 'Willkommen zurück',
    subtitle: 'Melden Sie sich bei Ihrem Konto an',
    email: 'E-Mail-Adresse',
    password: 'Passwort',
    signIn: 'Anmelden',
    noAccount: 'Noch kein Konto?',
    createAccount: 'Konto erstellen',
    registerTitle: 'Konto erstellen',
    name: 'Vollständiger Name',
    phone: 'Telefonnummer',
    alreadyHaveAccount: 'Bereits ein Konto?',
    backToLogin: 'Zurück zur Anmeldung',
    buyerType: 'Kontotyp',
    retail: 'Privatkunde',
    wholesale: 'Großhändler',
    register: 'Jetzt registrieren',
    loginError: 'Ungültige E-Mail oder Passwort',
    brandTagline: 'Luxus-Teppiche, handgefertigt in Bhadohi',
  },

  // ─── Orders ───────────────────────────────────────────────
  orders: {
    title: 'Meine Bestellungen',
    subtitle: 'Alle Ihre Bestellungen im Überblick',
    orderId: 'Bestell-ID',
    date: 'Datum',
    status: 'Status',
    total: 'Gesamtbetrag',
    items: 'Artikel',
    viewDetails: 'Details ansehen',
    noOrders: 'Noch keine Bestellungen',
    noOrdersSub: 'Ihre Bestellungen erscheinen hier, sobald Sie einen Kauf getätigt haben.',
    orderDetails: 'Bestelldetails',
    backToOrders: '← Zurück zu meinen Bestellungen',
    shippingAddress: 'Lieferadresse',
    paymentInfo: 'Zahlungsinformationen',
    orderItems: 'Bestellte Artikel',
    statuses: {
      pending: 'Ausstehend',
      paid: 'Bezahlt',
      failed: 'Fehlgeschlagen',
      shipped: 'Versandt',
      delivered: 'Geliefert',
      cancelled: 'Storniert',
    },
  },

  // ─── Order Success ─────────────────────────────────────────
  orderSuccess: {
    title: 'Bestellung erfolgreich!',
    subtitle: 'Ihre Bestellung wurde aufgegeben',
    message: 'Vielen Dank für Ihren Einkauf. Sie erhalten in Kürze eine Bestätigungs-E-Mail.',
    orderNumber: 'Bestellnummer',
    continueShopping: 'Weiter einkaufen',
    viewOrder: 'Bestellung verfolgen',
    emailSent: 'Eine Bestätigung wurde an Ihre E-Mail-Adresse gesendet.',
  },

  // ─── Contact ──────────────────────────────────────────────
  contact: {
    label: 'KONTAKT',
    title: 'Wir freuen uns auf\nIhre Nachricht',
    subtitle: 'Fragen zu unseren Teppichen, individuellen Bestellungen oder Händlerprogramm? Wir helfen Ihnen gerne weiter.',
    showroom: 'Unser Showroom',
    emailUs: 'E-Mail',
    callUs: 'Telefon',
    hours: 'Mo – Sa, 10:00 – 19:00 Uhr IST',
    followUs: 'Social Media',
    namePlaceholder: 'Ihr Name *',
    emailPlaceholder: 'E-Mail-Adresse *',
    phonePlaceholder: 'Telefonnummer',
    selectSubject: 'Betreff auswählen',
    subjectOrder: 'Bestellanfrage',
    subjectCustom: 'Individuelle Bestellung',
    subjectTrade: 'Händlerprogramm',
    subjectShipping: 'Versand',
    subjectOther: 'Sonstiges',
    messagePlaceholder: 'Ihre Nachricht *',
    send: 'Nachricht absenden',
    successTitle: 'Nachricht gesendet!',
    successMsg: 'Vielen Dank für Ihre Kontaktaufnahme. Wir melden uns innerhalb von 24 Stunden bei Ihnen.',
    getInTouch: 'KONTAKTIEREN SIE UNS',
  },

  // ─── Trade Page ───────────────────────────────────────────
  trade: {
    label: 'HANDELSPROGRAMM',
    heroLabel: 'FÜR DEN HANDEL',
    title: 'Exklusiv für die Handelsbranche',
    subtitle: 'Wir arbeiten mit Architekten, Innenarchitekten und Hoteliers weltweit zusammen.',
    cta: 'Jetzt anfragen',
    formTitle: 'Handelsanfrage stellen',
    benefits: 'Ihre Vorteile als Handelspartner',
  },

  // ─── Footer ───────────────────────────────────────────────
  footer: {
    tagline: 'Premium-Teppiche aus Bhadohi, Indien – handgefertigt für die Welt.',
    shop: 'Shop',
    company: 'Unternehmen',
    legal: 'Rechtliches',
    allRugs: 'Alle Teppiche',
    newArrivals: 'Neuankömmlinge',
    custom: 'Individuelle Bestellung',
    trade: 'Großhandel',
    stories: 'Unsere Geschichte',
    blog: 'Blog',
    contact: 'Kontakt',
    about: 'Über uns',
    privacy: 'Datenschutz',
    terms: 'AGB',
    shipping: 'Versandrichtlinien',
    copyright: (year) => `© ${year} Kaaleen Haus. Alle Rechte vorbehalten.`,
    newsletter: {
      title: 'Newsletter abonnieren',
      placeholder: 'Ihre E-Mail-Adresse',
      button: 'Abonnieren',
    },
    madeWith: 'Handgefertigt in Indien',
    handcrafted: 'Handgefertigt in Bhadohi, Indien',
  },

  // ─── Stories ──────────────────────────────────────────────
  stories: {
    title: 'Unsere Geschichten',
    readMore: 'Mehr lesen',
    backToStories: '← Zurück',
    viewAll: 'Alle Geschichten',
  },

  // ─── Custom Page ──────────────────────────────────────────
  custom: {
    title: 'Individuelle Teppichgestaltung',
    subtitle: 'Gestalten Sie Ihren Traumteppich nach Maß',
    cta: 'Jetzt anfragen',
  },

  // ─── Common ───────────────────────────────────────────────
  common: {
    loading: 'Wird geladen...',
    error: 'Ein Fehler ist aufgetreten',
    notFound: 'Nicht gefunden',
    backHome: 'Zur Startseite',
    viewAll: 'Alle ansehen',
    learnMore: 'Mehr erfahren',
    close: 'Schließen',
    from: 'Ab',
    approxEur: 'ca.',
    new: 'Neu',
    off: 'RABATT',
    handcrafted: 'Handgefertigt',
  },
};
